import moment from "moment";
import React from "react";
import { useNavigate } from "react-router-dom";

const TableItem = ({ data }) => {
  const navigate = useNavigate();
  return (
    <tr
      className="py-3"
      style={{
        height: "4rem",
        verticalAlign: "middle",
      }}
    >
      <td>
        <small
          style={{
            fontWeight: "500",
            textTransform: "capitalize",
            color: "green",
          }}
        >
          ${data?.total_amount}
        </small>
      </td>
      <td>
        <small style={{ fontWeight: "500" }}>
          {data?.created
            ? moment(data?.created).format("MMM Do YYYY, h:mma")
            : "Not Specified"}
        </small>
      </td>
      <td>
        <small style={{ fontWeight: "500", textTransform: "capitalize" }}>
          {data?.name || "-"}
        </small>
      </td>
      <td>
        <small style={{ fontWeight: "500", textTransform: "capitalize" }}>
          {data?.status}
        </small>
      </td>
      <td>
        <button
          onClick={() => {
            navigate(`/clinics/${data.id}`);
          }}
          className="primary-btn-small"
          style={{ padding: "0px !important" }}
        >
          Reminder
        </button>
      </td>
    </tr>
  );
};

const InvoicingHisotryTable = ({ data }) => {
  return (
    <table className="table my-3 px-2">
      <thead className="thead-light" style={{ backgroundColor: "#F9FAFB" }}>
        <tr
          style={{
            height: "4rem",
            verticalAlign: "middle",
          }}
        >
          <th scope="col">
            <span className="muted-text">AMOUNT</span>
          </th>
          <th scope="col">
            <span className="muted-text">CREATED</span>
          </th>
          <th scope="col">
            <span className="muted-text">PAID ON</span>
          </th>
          <th scope="col">
            <span className="muted-text">STATUS</span>
          </th>
          <th scope="col">
            <span className="muted-text">ACTION</span>
          </th>
        </tr>
      </thead>
      <tbody>
        {data?.map((item) => {
          return <TableItem data={item} key={item.id} />;
        })}
      </tbody>
    </table>
  );
};

export default InvoicingHisotryTable;
